<template>
    <div class="wd-color-picker-anchor"
         :style="{'top': position[0], 'left': position[1]}">
        <div class="wd-color-picker-frame">
            <div class="wd-color-picker-item"
                 v-for="(color, index) in colors"
                 v-on:click="selectColor(index)"
                 :key="color.hex"
                 :style="{'background-color': color.hex}"
                 :class="{'wd-active-color-picker-item': index === activeColor}">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ColorPicker',
    props: [
        'position',
        'onSelect',
    ],
    data() {
        return {
            colors: [
                {
                    hex: '#F6F6F6',
                },
                {
                    hex: '#293133',
                },
            ],
            activeColor: 1,
        };
    },
    methods: {
        selectColor(id) {
            this.activeColor = id;
            this.onSelect(this.colors[id].hex);
        },
    },
};
</script>

<style scoped>
    .wd-color-picker-anchor {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        z-index: 2;
    }

    .wd-color-picker-frame {
        position: relative;
        display: grid;
        width: max-content;
        height: max-content;
        padding: 10px;
        border-radius: 5px;
        grid-template-columns: max-content max-content max-content;
        grid-column-gap: 10px;
        grid-row-gap: 10px;
        background-color: white;
    }

    .wd-color-picker-item {
        width: 40px;
        height: 40px;
        border-radius: 20px;
        border: 1px solid #70707010;
        background-color: #d7d7d7;
        cursor: pointer;
        user-select: none;
    }

    .wd-color-picker-item:hover {
        border: 1px solid #70707080;
    }

    .wd-active-color-picker-item {
        border-color: #707070 !important;
    }
</style>
